@if (loading()) {
<div class="w-full h-screen flex items-center justify-center">
  <app-loading></app-loading>
</div>
} @else if (loginError()) {
<div class="w-full max-h-full lg:h-screen flex items-center justify-center">
  <div class="text-white text-center">
    <h2 class="text-lg font-semibold">Authentication Issue</h2>
    <p class="mt-2">The application was unable to sign you in with your selected account.<br />
      Sign out and try again in a private browser session. If the problem persists, please reach out to your Cegeka
      contact.</p>
  </div>
</div>
} @else {
<div class="text-slate-50 flex flex-col p-8 gap-6 max-h-full lg:h-screen min-h-0 overflow-y-auto">
  @if (currentWorkspaces().length > 0) {
  <div class="flex w-full items-center justify-between">
    <app-workspace-selector></app-workspace-selector>
    <div class="flex gap-4 items-center">
      <!-- READER -->
      @if(applicationState.isReader()) {

      <label class="flex items-center gap-2 cursor-pointer">
        <span class="text-xs text-slate-400">{{ showAllReports() ? 'All Reports' : 'Products Only' }}</span>
        <input type="checkbox" class="toggle toggle-primary toggle-sm" [checked]="showAllReports()"
          (change)="showAllReports.set($any($event.target).checked)" />
      </label>
      <!-- <button class="pr-4 flex items-center gap-2 text-xs bg-base-100/5 backdrop-blur-sm border-base-100/15 p-2 border 
           hover:bg-base-100/10">
        <span class="material-symbols-outlined">
          export_notes
        </span>
        <span>Reporting</span>
      </button>  -->
      }
      <app-notification-card></app-notification-card>
    </div>
  </div>
  @if (visibleReports().length === 0) {
  <p class=" text-slate-400 text-sm xl:text-base leading-5 xl:leading-6 tracking-normal w-2/3">
    It seems like you have not bought any dashboards yet. Check out the
    available dashboards below.
  </p>
  } @else {
  <h2 class="text-white leading-6 ml-2">Your Dashboards</h2>
  <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
    @for (r of visibleReports(); track r.id) {
    <app-report-card [report]="r" [product]="getProductFromReport(r)"></app-report-card>
    }
  </div>
  }
  @if (notBoughtProducts().length > 0) {
  <div>
    <div class="flex items-center gap-x-2 ">
      @if (visibleReports().length > 0) {
      <h2>Also</h2>
      }

      <h2 class="text-white leading-6 inline">available</h2>

      @if (visibleReports().length === 0) {
      <h2>Dashboards</h2>
      }
    </div>

    <p class=" text-slate-400 text-sm leading-5 lg:leading-5 tracking-normal w-full lg:w-2/3">
      Each dashboard provides a central view on a specific cloud category.
      Multiple data sources are intertwined in order to provide a full view
      for that category without the need for checking multiple dashboards
      that provide a part of the required view. Click on a dashboard to
      learn more.
    </p>
  </div>

  <div class="flex flex-wrap gap-2 lg:gap-4 items-center justify-start">
    @for (product of notBoughtProducts(); track product.id) {
    <button (click)="goToProduct(product.name)"
      class="gap-4 lg:gap-2 card flex flex-row lg:flex-col items-center lg:justify-center p-1.5 h-fit w-full lg:h-[100px] lg:w-[130px] border-b-4 border-transparent hover:border-b-4 hover:border-primary/50">
      <span class="!text-3xl material-symbols-outlined ">{{
        product.material_icon
        }}</span>
      <h5 class="text-xs text-slate-300">{{ product.name }}</h5>
    </button>
    }
  </div>
  }
  } @else if (!loading()) {
  <div class="w-full h-full flex items-center justify-center">
    <div class="text-white text-center max-w-[640px] mx-auto">
      <h2 class="text-lg font-semibold">No workspaces available</h2>
      <p class="mt-2">
        We couldn't find any workspaces linked to your account.<br />
        If you recently received access or had to set up MFA during sign-in, please note
        that it might take up to 30 minutes <span class="underline">after signing in</span> before your workspaces
        become available.
      </p>
      <p class="mt-2">
        Please retry later. If the problem persists, please reach out to your Cegeka contact.
      </p>
    </div>
  </div>
  }
</div>
}